module.exports = __webpack_public_path__ + "img/logo2.118228d3.png";